goog.provide("shadow.js.shim.module$$mui$x_charts");
goog.provide("module$shadow_js_shim_module$$mui$x_charts");
shadow.js.shim.module$$mui$x_charts = shadow.js.nativeProvides["@mui/x-charts"] = shadow$bridge("@mui/x-charts");
module$shadow_js_shim_module$$mui$x_charts.default = shadow.js.shim.module$$mui$x_charts;
